<a class="matero-branding" href="#/" fxLayoutGap="16px">
  <img src="./assets/img/vanuma.png" class="matero-branding-logo-expanded" alt="logo" />
  <span class="matero-branding-name" [ngClass.xs]="{'miniName': true}">
    <small>
      Mama Dubu
    </small>
  </span>
</a>
